import type { LanguageCode } from '../game/types'

const localeFor = (lang: LanguageCode) =>
  lang === 'en' ? ('en-GB' as const) : ('nl-NL' as const)

export function formatDateTime(
  lang: LanguageCode,
  value: number | Date,
): string {
  const d = typeof value === 'number' ? new Date(value) : value
  return d.toLocaleString(localeFor(lang))
}

/** Date + time without seconds (e.g. trip reports). */
export function formatDateTimeShort(
  lang: LanguageCode,
  value: number | Date,
): string {
  const d = typeof value === 'number' ? new Date(value) : value
  return d.toLocaleString(localeFor(lang), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Duration label for expedition timers */
export function formatDurationMs(_lang: LanguageCode, ms: number): string {
  const m = Math.floor(ms / 60000)
  const s = Math.floor((ms % 60000) / 1000)
  if (m === 0) return `${s}s`
  if (s === 0) return `${m} min`
  return `${m}m ${s}s`
}
